var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 27,
    viewBox: "0 0 171 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4326 0L24.1953 9.96304L29.9662 19.926L32.8435 24.9116L35.7289 19.926L38.6062 14.9405L35.7289 9.96304H41.4916L44.3689 4.98558L47.2543 0H18.4326Z",
    fill: "url(#paint0_linear_42_1377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.8217 26.5695L23.059 16.6065L17.2882 6.6435L14.4109 1.65797L11.5255 6.6435L8.64814 11.629L11.5255 16.6065H5.76272L2.88541 21.5839L0 26.5695H28.8217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.4067 23.5969L52.429 19.12C54.5981 20.698 57.8337 21.7987 60.9222 21.7987C64.4519 21.7987 65.8857 20.6246 65.8857 19.0462C65.8857 14.2389 50.9214 17.5416 50.9214 8.00009C50.9214 3.63312 54.4511 -7.62939e-06 61.7679 -7.62939e-06C65.0033 -7.62939e-06 68.3124 0.770724 70.7022 2.27531L68.864 6.78905C66.4741 5.43124 64.0105 4.77077 61.7311 4.77077C58.2013 4.77077 56.8409 6.0917 56.8409 7.70655C56.8409 12.4408 71.8053 9.17463 71.8053 18.6059C71.8053 22.8999 68.2389 26.5695 60.8854 26.5695C56.8042 26.5695 52.6863 25.3585 50.4067 23.5969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M96.7336 21.3584V26.1292H76.8057V0.440308H96.2555V5.21109H82.7252V10.7891H94.6745V15.4131H82.7252V21.3584L96.7336 21.3584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M118.794 26.1292L113.831 18.9729H108.353V26.1292H102.396V0.440308H113.537C120.412 0.440308 124.714 4.00004 124.714 9.76171C124.714 13.615 122.765 16.4409 119.419 17.8721L125.192 26.1292L118.794 26.1292ZM113.206 5.28447H108.353V14.239H113.206C116.846 14.239 118.684 12.5507 118.684 9.76171C118.684 6.93582 116.846 5.28447 113.206 5.28447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M152.657 9.76171C152.657 15.4865 148.355 19.0462 141.48 19.0462H136.296V26.1292H130.34V0.440308H141.48C148.355 0.440308 152.657 4.00004 152.657 9.76171ZM146.627 9.76171C146.627 6.93582 144.789 5.28447 141.149 5.28447H136.296V14.2021H141.149C144.789 14.2021 146.627 12.5507 146.627 9.76171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M156.379 23.4535L157.72 21.7882C159.306 23.3718 161.248 24.491 163.874 24.491C166.773 24.491 168.25 22.9074 168.25 21.215C168.25 19.222 166.473 18.4302 163.19 17.6655C159.415 16.792 157.036 15.6178 157.036 12.369C157.036 9.36581 159.716 7.01787 163.327 7.01787C166.117 7.01787 168.196 8.10999 169.919 9.6936L168.606 11.3589C167.047 9.85731 165.187 8.95636 163.218 8.95636C160.892 8.95636 159.196 10.4854 159.196 12.2052C159.196 14.1437 161.057 14.8264 164.257 15.5907C167.84 16.4371 170.411 17.7204 170.411 21.0239C170.411 23.9995 168.168 26.4295 163.792 26.4295C160.701 26.4295 158.267 25.3103 156.379 23.4535Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_1377",
    x1: 17.9161,
    y1: -2.74307,
    x2: 36.3138,
    y2: 9.93831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.c5a083c39eb6e99d84d466ae45c4a6dd.svg";
export { ForwardRef as ReactComponent };